import { useState, FormEvent } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [newsletterStatus, setNewsletterStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleNewsletterSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setNewsletterStatus('idle');

    if (!email) {
      setNewsletterStatus('error');
      return;
    }

    try {
      const formBody = new URLSearchParams();
      formBody.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d6b94k6a728k8ctu3p4g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setNewsletterStatus('success');
        setEmail('');
      } else {
        setNewsletterStatus('error');
      }
    } catch (error) {
      setNewsletterStatus('error');
    }
  };

  return (
    <footer id="contact" className="bg-[#2B2B2B] text-white pt-20 pb-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div>
            <img
              src="https://static.readdy.ai/image/91846066053649284e91c1730b38112a/93e2cec226b73ee4685c8159598e7006.png"
              alt="Design Assist Logo"
              className="h-10 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Empowering interior designers with trade pricing access and seamless procurement solutions from factory to fulfillment.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider mb-4 text-[#C5A572]">STAY UPDATED</h4>
            <form id="newsletter-form" onSubmit={handleNewsletterSubmit} data-readdy-form>
              <div className="flex items-center border-b border-[#C5A572]/40 pb-2 mb-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email"
                  className="bg-transparent flex-1 outline-none text-sm text-white placeholder-gray-500"
                  required
                />
                <button
                  type="submit"
                  className="cursor-pointer"
                  aria-label="Subscribe to newsletter"
                >
                  <i className="ri-arrow-right-line text-[#C5A572]"></i>
                </button>
              </div>
              {newsletterStatus === 'success' && (
                <p className="text-green-400 text-xs">Subscribed successfully!</p>
              )}
              {newsletterStatus === 'error' && (
                <p className="text-red-400 text-xs">Please enter a valid email.</p>
              )}
            </form>
            <a href="#" className="text-xs text-gray-500 hover:text-gray-400 cursor-pointer">
              Privacy Policy
            </a>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider mb-4 text-[#C5A572]">COMPANY</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-white hover:text-[#C5A572] transition-colors text-sm cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-white hover:text-[#C5A572] transition-colors text-sm cursor-pointer"
                >
                  Our Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('how-it-works')}
                  className="text-white hover:text-[#C5A572] transition-colors text-sm cursor-pointer"
                >
                  How It Works
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-white hover:text-[#C5A572] transition-colors text-sm cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact-us')}
                  className="text-white hover:text-[#C5A572] transition-colors text-sm cursor-pointer"
                >
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider mb-4 text-[#C5A572]">CONTACT</h4>
            <ul className="space-y-3">
              <li>
                <a href="mailto:hello@designassist.com" className="text-white hover:text-[#C5A572] transition-colors text-sm cursor-pointer">
                  hello@designassist.com
                </a>
              </li>
              <li>
                <a href="tel:+15551234567" className="text-white hover:text-[#C5A572] transition-colors text-sm cursor-pointer">
                  (555) 123-4567
                </a>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact-us')}
                  className="text-white hover:text-[#C5A572] transition-colors text-sm cursor-pointer"
                >
                  Schedule Call
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mb-12">
          <div className="text-7xl md:text-8xl font-bold text-[#C5A572]/10 tracking-tighter">
            DESIGN ASSIST
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
          <p>&copy; 2025 Design Assist. All rights reserved.</p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-[#C5A572] transition-colors cursor-pointer mt-4 md:mt-0"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
